import { heroStats, siteMeta } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="relative pt-24 md:pt-28">
      <div className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20cinematic%20streaming%20backdrop%20with%20warm%20amber%20and%20crimson%20light%20streaks%20across%20a%20deep%20charcoal%20gradient%2C%20soft%20bokeh%20particles%20and%20glowing%20screen%20glow%20suggesting%20a%20home%20media%20lounge%2C%20dramatic%20contrast%20ideal%20for%20white%20headline%20text%20overlay%2C%20stylized%20editorial%20gradient%20art%2C%20no%20text%2C%20no%20logos%2C%20moody%20high%20contrast%20composition&width=1920&height=1080&seq=miyue-tv-hero-01&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65" aria-hidden="true" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-transparent" aria-hidden="true" />

        <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-3 py-1.5 text-xs md:text-sm text-background-50 backdrop-blur-sm">
              <i className="ri-bookmark-3-line" aria-hidden="true" />
              访问指引 · 网址汇总 · 下载导航
            </span>

            <h1 className="mt-5 font-heading font-black text-background-50 text-3xl md:text-5xl leading-tight">
              蜜月TV官网入口与最新地址导航
            </h1>

            <p className="mt-5 text-background-50/85 text-sm md:text-lg leading-relaxed max-w-2xl">
              本站把蜜月TV的官网入口、最新可用网址与APP下载方式整理在一处，帮你快速找到能打开的地址，
              避开已经失效或仿冒的链接，一步进入平台观看内容。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#latest-address"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-links-line" aria-hidden="true" />
                查看最新可用网址
              </a>
              <a
                href="#app-download"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium backdrop-blur-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-download-2-line" aria-hidden="true" />
                下载APP客户端
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 max-w-xl">
              {heroStats.map((stat) => (
                <div key={stat.label} className="border-l-2 border-primary-400/70 pl-3">
                  <dt className="text-background-50/70 text-xs">{stat.label}</dt>
                  <dd className="mt-1 font-heading font-bold text-background-50 text-lg md:text-xl">
                    {stat.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>

      <div className="bg-background-100 border-b border-background-200">
        <div className="px-4 md:px-6 py-3 text-center text-xs md:text-sm text-foreground-600">
          <i className="ri-information-line mr-1.5" aria-hidden="true" />
          {siteMeta.name}不存储任何影视资源，本页仅提供访问与下载指引，实际内容请以播出页面为准。
        </div>
      </div>
    </section>
  );
}